import { useSelector } from 'react-redux'
import { amIBlockedByExclusiveUiSelector } from '../selectors'

export const useAmIBlockedByExclusiveUi = () => {
  return useSelector(amIBlockedByExclusiveUiSelector)
}
